import { getImageUrl } from 'ui-images';
export const mrHubBot = getImageUrl('robot-small');